import React from 'react';
import './BioFotografo.css';

export default function BioFotografo(){
  return (
    <section className="bio-wrap">
      <div className="bio-inner">
        <div className="bio-img">
          <img
            src="/images/juan-home.png"
            alt="Fotógrafo"
            draggable="false"
            onContextMenu={(e)=>e.preventDefault()}
          />
        </div>
        <div className="bio-text">
          <h2 className="home-subtitle">Sobre el fotógrafo</h2>
          <p>
            Mi trabajo explora la relación entre momento, luz y textura. Busco que cada imagen
            sobreviva al instante y conecte con quien la observa. Las impresiones se realizan
            con papeles fine art y procesos de archivo para asegurar calidad y permanencia.
          </p>
          <p className="bio-links">
            <a href="/sobre-mi" className="bio-btn glass">Sobre mí</a>
            <a href="/contacto" className="bio-btn glass solid">Contacto</a>
          </p>
        </div>
      </div>
    </section>
  );
}
